import React, { useState, useEffect } from 'react';
import { ThemeProvider } from './theme-provider';
import Header from './header.js';
import HeroSection from './hero-section.js';
import FounderNote from './founder-note.js';
// import HowItWorksSection from './how-it-works-section.js';
import FeaturesSection from './features-section.js';
import IndustryApplications from './industry-applications-section.js';
// import TestimonialsSection from './testimonials-section.js';
import PricingSection from './pricing-section.js';
import CtaSection from './cta-section.js';
import Footer from './footer.js';
import EarlyAccessModal from './EarlyAccessModal.js';
import ScrollToHashElement from '../../components/ScrollToHashElement';

// Create context for modal management
export const ModalContext = React.createContext();

const LandingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [componentsLoaded, setComponentsLoaded] = useState({
    pricing: false,
    testimonials: false
  });

  const openModal = (plan = null) => {
    setSelectedPlan(plan);
    setModalOpen(true);
  };

  // Load chatbot script
  useEffect(() => {
    const script = document.createElement('script');
    // Use local development version for localhost and staging
    const isDevelopment = window.location.hostname === 'localhost' || 
                          window.location.hostname === '127.0.0.1' ||
                          window.location.hostname.includes('staging.smushlabs.ai');
    script.src = isDevelopment ? "/chatbot-loader.js" : "https://www.smushlabs.ai/chatbot-loader.js";
    script.onload = () => {
      // Initialize chatbot after script loads
      const CHATBOT_ID = '22691f44-f807-4a7e-82b9-130355c949b2';
      if (window.smushchatChatbot) {
        window.smushchatChatbot.init(CHATBOT_ID, 'right');
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Pre-load components when page is idle
  useEffect(() => {
    // Use requestIdleCallback for non-critical UI components
    if ('requestIdleCallback' in window) {
      // Schedule loading of non-critical components during idle time
      const idleCallback = window.requestIdleCallback(() => {
        setComponentsLoaded({
          pricing: true,
          testimonials: true
        });
      }, { timeout: 2000 }); // 2 second timeout if the browser remains busy
      
      return () => 'cancelIdleCallback' in window && window.cancelIdleCallback(idleCallback);
    } else {
      // Fallback for browsers that don't support requestIdleCallback
      const timeoutId = setTimeout(() => {
        setComponentsLoaded({
          pricing: true,
          testimonials: true
        });
      }, 1000);
      
      return () => clearTimeout(timeoutId);
    }
  }, []);

  return (
    <ThemeProvider defaultTheme="system">
      <ModalContext.Provider value={{ openModal }}>
        <div className="min-h-screen flex flex-col">
          <ScrollToHashElement />
          <Header />
          <main className="flex-1">
            <HeroSection />
            <FounderNote />
            <FeaturesSection />
            <IndustryApplications />
            {componentsLoaded.pricing && <PricingSection />}
            <CtaSection />
            {/* <HowItWorksSection /> */}
            {/* {componentsLoaded.testimonials && <TestimonialsSection />} */}
          </main>
          <Footer />
          <EarlyAccessModal 
            isOpen={modalOpen} 
            setIsOpen={setModalOpen} 
            selectedPlan={selectedPlan} 
          />
        </div>
      </ModalContext.Provider>
    </ThemeProvider>
  );
};

export default LandingPage; 